"use strict";import{MenuItem as e}from"./src/MenuItem.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-menu-item",e);
//# sourceMappingURL=sp-menu-item.js.map
